import * as Phaser from "phaser";
import { InteractiveRoomItem } from "$/game/prefabs/InteractiveRoomItem.ts";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export class BowlInteractiveObject extends InteractiveRoomItem {
  private foodCountText: Phaser.GameObjects.Text;
  private plusButton: Phaser.GameObjects.Text;

  constructor(private myScene: BasicScene, x: number, y: number) {
    super(myScene, x, y, myScene.atlas, myScene.keys.assets.sprites.items.bowl);

    this.setOnClickCallback(() => {
    });

    // Текст с количеством еды под миской
    this.foodCountText = myScene.add.text(
      x - 25,
      y + this.displayHeight / 2 + 15,
      `${this.myScene.storage.pet()?.food ?? 0}`,
      {
        fontSize: "32px",
        color: "#" + myScene.global.TUNER_TWA_CONFIG.palette.text.toString(16),
        fontFamily: "Phantom-Muff",
        fontStyle: "bold",
      },
    ).setOrigin(0.5, 0);

    // Кнопка "+" справа от текста
    this.plusButton = myScene.add.text(
      x + 15,
      y + this.displayHeight / 2 + 15,
      "➕",
      {
        fontSize: "28px",
      },
    )
      .setOrigin(0.5, 0)
      .setInteractive({ useHandCursor: true });

    // Обработчик клика на плюсик
    this.plusButton.on("pointerdown", () => {
      if (myScene.settings.getSetting("isVibrationEnabled")) {
        myScene.telegram.twaSDK.hapticFeedback.impactOccurred("light");
      }
      const pet = myScene.registry.get("pet");
      myScene.overlay.show("FoodShopOverlay", true, { pet });
    });

    // Анимация при наведении на плюсик
    this.plusButton.on("pointerover", () => {
      myScene.tweens.add({
        targets: this.plusButton,
        scaleX: 1.2,
        scaleY: 1.2,
        duration: 150,
        ease: "Power2",
      });
    });

    this.plusButton.on("pointerout", () => {
      myScene.tweens.add({
        targets: this.plusButton,
        scaleX: 1,
        scaleY: 1,
        duration: 150,
        ease: "Power2",
      });
    });

    // Подписка на изменения данных питомца для обновления счётчика еды
    myScene.registry.events.on("changedata-pet", () => {
      if (this.active && this.foodCountText.active) {
        this.updateFoodCount();
      }
    });
  }

  private updateFoodCount(): void {
    const pet = this.myScene.storage.pet();
    if (pet && this.foodCountText) {
      this.foodCountText.setText(`${pet.food ?? 0}`);
    }
  }

  override destroy(): void {
    if (this.foodCountText) {
      this.foodCountText.destroy();
    }
    if (this.plusButton) {
      this.plusButton.destroy();
    }
    super.destroy();
  }
}
